import { ApiProperty } from "@nestjs/swagger";

export class SKechersOrderDetailsReq {
   
    @ApiProperty()
    poNumber: string;

    @ApiProperty()
    poStyle: string;

    @ApiProperty()
    deliveryAddress?: string;

}